import { render, staticRenderFns } from "./CertificatePreview.vue?vue&type=template&id=a0c25196&scoped=true&"
import script from "./CertificatePreview.vue?vue&type=script&lang=js&"
export * from "./CertificatePreview.vue?vue&type=script&lang=js&"
import style0 from "./CertificatePreview.vue?vue&type=style&index=0&id=a0c25196&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0c25196",
  null
  
)

export default component.exports